"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import { isLocalEnv } from "./utils/misc/helperFns";
import useToolkit from "@/hooks/misc/useToolkit";
import SessionTimeoutModal from "@/components/common/modals/SessionTimeoutModal";
import { closeSessionReload } from "@/redux/slices/userSlice";
import GlobalMiddleware from "@/components/layouts/GlobalMiddleware";

export default function ReactQueryProvider({ children }: { children: React.ReactNode }) {
  const { dispatch, useAppSelector } = useToolkit()
  const { sessionReloadOpen } = useAppSelector((state) => state.user)

  const [queryClient] = useState(() =>
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          refetchOnReconnect: true,
          retry: 2,
          staleTime: 5 * 60 * 1000,
        },
        mutations: {}
      },
    })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalMiddleware />
      <SessionTimeoutModal
        open={sessionReloadOpen}
        onClose={() => {
          dispatch(closeSessionReload())
        }}
      />

      {children}

      {isLocalEnv && (
        <ReactQueryDevtools
          initialIsOpen={false}
        />
      )}
    </QueryClientProvider>
  );
}
